import GoToEventCard from 'Components/Card/Variants/Card.GoToEventCard';

function LiveQAWebinarCard(props) {
    return GoToEventCard(props);
}

export default LiveQAWebinarCard;